import { createActionCreator } from "common/ReduxUtils";
import { StorageSelectShippingActionTypes } from "../StorageSelectShippingActionTypes";

export const resetSelectedQuoteDetails = createActionCreator(
  StorageSelectShippingActionTypes.RESET_STORAGE_SELECTED_QUOTE_DETAILS
);
